import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import bg1 from "../../assets/images/bg/Events.jpg";
import bg from "../../assets/images/bg/Events-m.jpg";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../../Config/FbConfig";
import ReactPaginate from "react-paginate";

export default function Courses() {
  const navigate = useNavigate();
  const [Courses, setCourses] = useState([]);
  const [bgImage, setBgImage] = useState(window.innerWidth <= 768 ? bg : bg1);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [loading, setLoading] = useState(true); // Loading state
  const [noData, setNoData] = useState(false); // No data available state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6; // Number of items per page

  useEffect(() => {
    const handleResize = () => {
      setBgImage(window.innerWidth <= 768 ? bg : bg1);
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [bg, bg1]);

  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true);
      try {
        const docRef = doc(firestore, "Home", "Events");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const Data = [];
          Object.entries(docSnap.data()).forEach(([key, value]) => {
            Data.push(Object.assign({ Id: key }, value));
          });
          const sortedCourses = Data.sort((a, b) => a.Priority - b.Priority);
          setCourses(sortedCourses);
          setNoData(sortedCourses.length === 0);
        } else {
          setCourses([]);
          setNoData(true);
        }
      } catch (error) {
        console.error("Error fetching courses: ", error);
        setNoData(true); // Set noData to true in case of an error
      } finally {
        setLoading(false); // Set loading to false once fetching is complete
      }
    };

    fetchCourses();
  }, []);

  const handleViewDetails = (item) => {
    navigate(`/event-details/${item.Id}`, { state: { event: item } });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Pagination logic
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedItems = Courses.slice(startIndex, endIndex);
  const totalPages = Math.ceil(Object.keys(Courses).length / itemsPerPage);

  

  return (
    <>
      <Navbar
        manuClass="navigation-menu nav-light nav-left"
        containerClass="container"
      />
      <section
        className="bg-half-170 d-table w-100"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="section-title text-center">
                <h3 className="sub-title mb-2 text-white title-dark">
                  Ranga Bandi ~ Events
                </h3>
                <p className="para-desc mx-auto text-white-50">
                  Theatre is the heartbeat of culture, keeping history alive and
                  dreams vivid
                </p>

                <nav aria-label="breadcrumb" className="d-inline-block mt-1">
                  <ul className="breadcrumb bg-light rounded mb-0 py-1 px-2">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li style={{color:"#B9B569"}} className="breadcrumb-item active" aria-current="page">
                      Ranga Bandi ~ Events
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="position-relative">
        <div className="shape overflow-hidden text-color-white">
          <svg
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </div>

      <section className="section">
        <div className="container">
          {loading ? (
            <div className="text-center">
              <p>Loading...</p>
            </div>
          ) : noData ? (
            <div className="text-center">
              <h5>No Events Available</h5>
            </div>
          ) : (
            <>
              <div className="row">
                {paginatedItems?.map((item, index) => (
                  <div
                    className="col-lg-4 col-md-6 col-12 mb-4 pb-2"
                    key={index}
                  >
                    <div className="card blog blog-primary border-0 shadow rounded overflow-hidden">
                      <img src={item.Image} className="img-fluid" alt="" />
                      <div className="card-body p-4">
                        <h6 className="one-line-truncate para-desc">
                          {item.Header}
                        </h6>
                        <p className="two-line-truncate para-desc text-muted justify">
                          {item.Description}
                        </p>
                        <div className="post-meta d-flex justify-content-between mt-3">
                          <p
                            onClick={() => handleViewDetails(item)}
                            style={{ cursor: "pointer", color: "#B9B569" }}
                          >
                            Read More
                            <i className="mdi mdi-chevron-right align-middle"></i>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="d-flex justify-content-center mt-4">
                <nav>
                  <ul className="pagination">
                    {[...Array(totalPages)].map((_, index) => (
                      <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                        <button style={{backgroundColor:"#B9B568"}} className="page-link" onClick={() => handlePageChange(index + 1)}>
                          {index + 1}
                        </button>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
            </>
          )}
        </div>
      </section>
      <Footer />
    </>
  );
}
